import styled from "styled-components";

const FlexCentered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export default FlexCentered;